import { ISchedule } from '../models';

export function setDaysCorrectOrder(schedule: ISchedule): ISchedule {
  const { hours: { Mon, Tue, Wed, Thu, Fri, Sat, Sun } } = schedule;
  schedule.hours = { Mon, Tue, Wed, Thu, Fri, Sat, Sun };

  return schedule;
}
